module.exports = __webpack_public_path__ + "img/wealth.767abf29.png";